import { Outlet } from 'react-router-dom'

import {
  Box,
  CircularProgress,
  Container,
  Toolbar,
  // useMediaQuery,
} from '@mui/material'

//import { useTheme } from '@mui/material/styles'
import useConfig from 'hooks/useConfig'
import Footer from '../MainLayout/Footer'
import Header from './Header'

// ==============================|| MAIN LAYOUT ||============================== //

const SubscriptionLayout = () => {
  const { workspace, container } = useConfig()

  return (
    <Box
      sx={{ display: 'flex', width: '100%' }}
      key={workspace}>
      <Header />
      <Box
        component="main"
        sx={{ width: 'calc(100% - 278px)', flexGrow: 1 }}>
        <Box sx={{ p: 1 }}>
          <Toolbar />
          {container && (
            <Container
              maxWidth={false}
              sx={{
                marginLeft: 0,
                px: { xs: 0, sm: 2 },
                py: 3,
                position: 'relative',
                minHeight: 'calc(100vh - 110px)',
                display: 'flex',
                flexDirection: 'column',
                maxWidth: '100%',
              }}>
              {workspace ? (
                <Outlet />
              ) : (
                <Box sx={{ display: 'flex', justifyContent: 'center', p: 5 }}>
                  <CircularProgress />
                </Box>
              )}
              <Footer />
            </Container>
          )}
          {!container && (
            <Box
              sx={{
                position: 'relative',
                minHeight: 'calc(100vh - 110px)',
                display: 'flex',
                flexDirection: 'column',
              }}>
              {workspace ? (
                <Outlet />
              ) : (
                <Box sx={{ display: 'flex', justifyContent: 'center', p: 5 }}>
                  <CircularProgress />
                </Box>
              )}
              <Footer />
            </Box>
          )}
        </Box>
      </Box>
    </Box>
  )
}

export default SubscriptionLayout
